'use es6';

import { SYSTEM } from '../constants/sourceTypes';
import { getSource } from './crmObjectLifecycleUpdateGetters';
export const isSystemUpdate = message => {
  return getSource(message) === SYSTEM;
};